export default __webpack_public_path__ + "static/slide3-de@2x-170e61779727a7e7731af2263c00254a.png";